/**
 * Base uri for api calls. e.g local development would be http://localhost:4000/api
 */
export const API_BASE_URI = process.env.REACT_APP_API_BASE_URI || '/';

export const AUTH0_DOMAIN =
    process.env.REACT_APP_AUTH0_DOMAIN || (process.env.NODE_ENV === 'production' ? 'cimplico.au.auth0.com' : 'cimplico-dev.au.auth0.com');

export const AUTH0_CLIENT_ID =
    process.env.REACT_APP_AUTH0_CLIENT_ID ||
    (process.env.NODE_ENV === 'production' ? 'JKhfS1HZgu4Ofgp74ZgkkiL0XknbYl6p' : 'S8TTgCGE2naGWbN7LABDnjR6YlHJZGmk');

export const AUTH0_AUDIENCE =
    process.env.REACT_APP_AUTH0_AUDIENCE ||
    (process.env.NODE_ENV === 'production' ? 'https://workpapers-api.cimplico.com' : 'https://workpapers-api.cimplicodev.com');

export const AUTH0_SCOPES = ['read:current_user', 'profile', 'email', 'offline_access'].join(' ');

export const DOMAIN =
    process.env.REACT_APP_DOMAIN || (process.env.NODE_ENV === 'production' ? 'https://www.cimplico.com' : 'https://www.cimplicodev.com');

export const FYI_URL =
    process.env.REACT_APP_FYI_URL || (process.env.NODE_ENV === 'production' ? 'https://app.fyidocs.com' : 'https://preprod.fyidocs.com');

export const INTERCOM_APP_ID = process.env.REACT_APP_INTERCOM_APP_ID;
